import { logError } from "~utils/newrelic/newrelicBrowser";

const ARTICLE_SECTION_TITLES: Record<string, string> = {
  stocks: "Stocks",
  currencies: "Currencies",
  "fx-fixings": "Currencies",
  "cross-rates": "Currencies",
  "rates-bonds": "Bonds",
  "consumer-interest-rates": "Bonds",
  commodities: "Commodities",
  energy: "Commodities",
  regions: "Stocks",
};

// Regex to match all <li>...</li> block following the Stocks <h3>
const LIST_ITEM_REGEX = /<li>(.*?)<\/li>/g;

// build regex dynamically based on the market data page identifier
function buildSectionRegex(sectionIdentifier: string): RegExp | null {
  const title = ARTICLE_SECTION_TITLES[sectionIdentifier];

  if (!title) {
    logError(
      new Error("Market Summaries Error: Could not find section identifier"),
      {
        sectionIdentifier,
      }
    );

    return null;
  }

  return new RegExp(`<h3>${title}<\\/h3>\\s*<ul>([\\s\\S]*?)<\\/ul>`);
}

function convertToPlainText(stocksHtml: string) {
  const tempDivElement = document.createElement("div");

  tempDivElement.innerHTML = stocksHtml;

  return tempDivElement.textContent || tempDivElement.innerText || "";
}

/**
 * Takes an input html string which has <h3>Stocks</h3> followed by a <ul> ...</ul> block
 * Returns an array of string where each string is a bullet point from the <ul> block
 * @param storyHtml story body of the markets wrap story in html format
 */
export function extractMarketMoves(
  storyHtml: string,
  sectionFrontName: string
): string[] {
  const sectionRegex = buildSectionRegex(sectionFrontName);

  if (!sectionRegex) return [];

  // E.g Match: <h3>Stocks</h3> followed by a <ul> ...</ul> block
  const mainMovesSectionMatch = storyHtml.match(sectionRegex);

  if (!mainMovesSectionMatch || mainMovesSectionMatch.length < 2) return [];

  const htmlBulletPoints = mainMovesSectionMatch[1];
  const extractedMarketMoves: string[] = [];

  let match: RegExpExecArray | null;

  // loop through all <li> elements within the <ul>
  while ((match = LIST_ITEM_REGEX.exec(htmlBulletPoints)) !== null) {
    const rawHtml: string = match[1];
    const plainText: string = convertToPlainText(rawHtml).trim();

    extractedMarketMoves.push(plainText);
  }

  return extractedMarketMoves;
}
